<template>
  <div>
    <div class="modal-card" style="width: auto">
      <b-loading :active.sync="isloadingUpdate" :can-cancel="false"></b-loading>
      <header class="modal-card-head">
        <p class="modal-card-title">{{ $t('index.edit_client_tokens_' + obj.licenseInfo.byod_type) }}</p>
      </header>

      <section class="modal-card-body">
        <div class="">
          <div class="columns">
            <div class="column">
              <b-field :label="'* ' + $t('index.select_configuration_' + obj.licenseInfo.byod_type)">
                <b-select @input="selectRoom" placeholder="Select the configuration and room" required v-model="localTokenVal.editKeyValues.configurationId" expanded>
                  <option v-for="conf in obj.configurations" v-bind:value="conf.id" v-bind:key="conf.id">{{ conf.name }}</option>
                </b-select>
              </b-field>
            </div>
          </div>

          <div>
            <b-field>
              <b-radio v-model="localTokenVal.editKeyValues.limitType" native-value="1" type="is-danger">
                {{ $t('index.limited_by_datetime') }}
              </b-radio>
            </b-field>
            <b-field>
              <b-radio v-model="localTokenVal.editKeyValues.limitType" native-value="2" type="is-info">
                {{ $t('index.unlimited_duration') }}
              </b-radio>
            </b-field>
          </div>
          <br />
          <div class="limit_type_2" v-if="localTokenVal.editKeyValues.limitType == 2">
            <div class="columns">
              <div class="column">
                <template>
                  <b-field :label="$t('index.check_frequency')">
                    <b-input type="number" min="1" max="7" icon="clock" :placeholder="$t('index.days')" v-model="localTokenVal.editKeyValues.frequencyCheckPeriod"> > </b-input>
                  </b-field>
                </template>
              </div>
            </div>
          </div>
          <div class="limit_type_1" v-if="localTokenVal.editKeyValues.limitType == 1">
            <div class="columns">
              <div class="column">
                <template>
                  <b-field :label="$t('index.arrival_date_' + obj.licenseInfo.byod_type)">
                    <b-datepicker :min-date="minDate" v-model="localTokenVal.editKeyValues.dateLifeFrom" placeholder="Click to select..." icon="calendar-alt"> </b-datepicker>
                  </b-field>
                </template>
              </div>
              <div class="column">
                <template>
                  <b-field :label="$t('index.arrival_time_' + obj.licenseInfo.byod_type)">
                    <b-timepicker hour-format="24" v-model="localTokenVal.editKeyValues.dateLifeFrom" placeholder="Type or select a date..." icon="clock" :readonly="false"> </b-timepicker>
                  </b-field>
                </template>
              </div>
            </div>

            <div class="columns">
              <div class="column">
                <template>
                  <b-field :label="$t('index.departure_date_' + obj.licenseInfo.byod_type)">
                    <b-datepicker :min-date="minDate" v-model="localTokenVal.editKeyValues.dateLifeTo" placeholder="Click to select..." icon="calendar-alt"> </b-datepicker>
                  </b-field>
                </template>
              </div>
              <div class="column">
                <template>
                  <b-field :label="$t('index.departure_time_' + obj.licenseInfo.byod_type)">
                    <b-timepicker hour-format="24" v-model="localTokenVal.editKeyValues.dateLifeTo" placeholder="Type or select a date..." icon="clock" :readonly="false"> </b-timepicker>
                  </b-field>
                </template>
              </div>
            </div>

            <div class="columns session_block">
              <div class="column">
                <div class="field">
                  <label class="label">{{ $t('index.session_time') }}</label>
                  <b-checkbox v-model="localTokenVal.editKeyValues.sessionTimeOption">{{ $t('index.custom_time_cb') }}</b-checkbox>
                </div>
              </div>
              <div class="column">
                <div class="field">
                  <b-tooltip label="Default and max value 30days (43200 minutes)" multilined>
                    <label class="label">{{ !localTokenVal.editKeyValues.sessionTimeOption ? $t('index.default') : $t('index.custom_time') }}</label>
                  </b-tooltip>
                  <div v-if="!localTokenVal.editKeyValues.sessionTimeOption">
                    <b>30 {{ $t('index.days') }}</b>
                  </div>
                  <div v-else>
                    <b-field>
                      <b-input type="number" min="1" max="43200" icon="clock" :placeholder="$t('index.minutes')" v-model="localTokenVal.editKeyValues.sessionTimeValue" />
                    </b-field>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <br />
          <div class="columns">
            <div class="column">
              <div class="field">
                <label class="label">{{ $t('index.email') }}</label>
                <div class="control">
                  <b-field :message="localTokenVal.editKeyValues.proLogin ? $t('index.used_as_login') : ''">
                    <b-input icon="envelope" type="email" v-model="localTokenVal.editKeyValues.email" :disabled="tokenVal.bxRightId" />
                  </b-field>
                </div>
              </div>
              <!-- <div class="field" v-if="obj.licenseInfo.user_manage">
                <div class="control">
                  <b-field>
                    <b-checkbox :disabled="localTokenVal.editKeyValues.proLogin||!localTokenVal.editKeyValues.email" v-model="localTokenVal.editKeyValues.proLogin">Used as login in i3pro for access to this configuration</b-checkbox>
                  </b-field>
                </div>
              </div> -->
            </div>
          </div>

          <div class="columns">
            <div class="column">
              <div class="field">
                <template>
                  <b-field :label="$t('index.activation_panels_limit')">
                    <b-input :placeholder="$t('index.activation_panels_limit_placeholder')" type="number" min="1" icon="clock" v-model="localTokenVal.editKeyValues.activationsCount" />
                  </b-field>
                </template>
              </div>
            </div>
          </div>

          <div class="columns is-multiline" style="max-width: 480px" v-if="fields.length">
            <b-loading :is-full-page="false" :active.sync="isLoading" :can-cancel="false"></b-loading>
            <div class="column is-half" v-for="(customField, i) in fields" :key="i" v-show="customField.edit">
              <div class="field">
                <label class="label">{{ customField.name }}</label>
                <div class="control">
                  <b-field>
                    <b-input type="text" @input="setCustomValue($event, customField, i)" v-model="customField.value"> </b-input>
                  </b-field>
                </div>
              </div>
            </div>
          </div>

          <div class="field">
            <b-checkbox type="is-danger" v-model="localTokenVal.editKeyValues.deactivated">{{ $t('index.force_deregister_client') }}</b-checkbox>
          </div>
        </div>
      </section>

      <footer class="modal-card-foot columns is-gapless">
        <div class="column is-half">
          <button class="button" type="button" @click="$parent.close()">{{ $t('index.cancel') }}</button>
        </div>
        <div class="column is-half has-text-right">
          <button v-if="localTokenVal.editKeyValues.deactivated" :disabled="!validate" class="button is-danger" @click="editKey">{{ $t('index.deactivate_registration') }}</button>
          <button v-else :disabled="!validate" class="button is-danger is-outlined" @click="editKey">{{ $t('index.edit_registration') }}</button>
        </div>
      </footer>
    </div>
  </div>
</template>
<script>
const today = new Date();
var moment = require('moment-timezone');
import FDateTime from './FDateTime.vue';
export default {
  components: {
    FDateTime,
  },
  props: ['objIndx', 'objData', 'tokenIndex', 'tokenVal'],
  data() {
    return {
      obj: this.objData,
      localTokenVal: this.tokenVal,
      minDate: new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1),
      fields: [],
      roomFields: [],
      isLoading: false,
      isloadingUpdate: false,
    };
  },
  computed: {
    validate() {
      if (!this.localTokenVal.editKeyValues.configurationId) {
        return false;
      }

      if (this.localTokenVal.editKeyValues.limitType == 2) {
        const frequency = parseInt(this.localTokenVal.editKeyValues.frequencyCheckPeriod);
        if (Number.isNaN(frequency) || frequency <= 0 || frequency > 7) {
          return false;
        }
      }

      if (this.localTokenVal.editKeyValues.limitType == 1) {
        if (this.localTokenVal.editKeyValues.sessionTimeOption) {
          const sess = parseInt(this.localTokenVal.editKeyValues.sessionTimeValue);

          if (Number.isNaN(sess) || sess <= 0 || sess > 43200) {
            return false;
          }
        }
      }
      return true;
    },
  },
  methods: {
    setCustomValue(event, curField, indexField) {
      this.$set(this.fields[indexField], 'defVal', this.roomFields[indexField].value === event);
    },
    selectRoom(confId) {
      this.isLoading = true;
      this.$http({
        method: 'post',
        url: `${this.$backendHost}/frontend/api/tokensfields/get`,
        transformResponse: [
          (data) => {
            return JSON.parse(data);
          },
        ],
        data: {
          configurationId: this.localTokenVal.editKeyValues.configurationId,
          objectId: this.localTokenVal.objectId,
          tokenId: this.localTokenVal.id,
        },
      })
        .then((response) => {
          this.isLoading = false;
          if (response.data.status) {
            console.error(response.data.error);
          } else {
            if (response.data.roomFields) {
              this.roomFields = response.data.roomFields.filter((f) => f.type === 1);
            }
            if (response.data.fields) {
              this.fields = response.data.fields
                .filter((f) => f.type === 1)
                .map((f, i) => {
                  f.defVal = response.data.fields[i].value === this.roomFields[i].value;
                  return f;
                });
            }
          }
        })
        .catch((error) => {
          this.isLoading = false;
          console.error(error);
        });
    },
    async editKey() {
      this.isloadingUpdate = true;
      try {
        const response = await this.$http({
          method: 'post',
          url: `${this.$backendHost}/frontend/api/keys/edit`,
          transformResponse: [
            (data) => {
              return JSON.parse(data);
            },
          ],
          data: {
            timezone: moment.tz.guess(),
            keyId: this.localTokenVal.id,
            objectId: this.localTokenVal.objectId,
            values: {
              deactivated: this.localTokenVal.editKeyValues.deactivated,
              comment: this.localTokenVal.editKeyValues.comment,
              clientName: this.localTokenVal.editKeyValues.clientName,
              email: this.localTokenVal.editKeyValues.email,
              limit: 1,
              dateLifeFrom: this.localTokenVal.editKeyValues.dateLifeFrom.getTime(),
              dateLifeTo: this.localTokenVal.editKeyValues.dateLifeTo.getTime(),
              configurationId: this.localTokenVal.editKeyValues.configurationId,
              sessionTime: !this.localTokenVal.editKeyValues.sessionTimeOption ? null : this.localTokenVal.editKeyValues.sessionTimeValue,

              limitType: this.localTokenVal.editKeyValues.limitType,
              frequencyCheckPeriod: parseInt(this.localTokenVal.editKeyValues.frequencyCheckPeriod) || null,
              activationsCount: parseInt(this.localTokenVal.editKeyValues.activationsCount) || null,

              fields: this.fields,
            },
          },
        });

        if (response.data.status) {
          this.$toast.open({
            message: response.data.error,
            position: 'is-bottom-right',
            type: 'is-error',
            container: 'div.modal-card',
          });
          this.isloadingUpdate = false;
          return;
        }

        if (this.tokenVal.bxRightId) {
          const data = this.localTokenVal.editKeyValues;

          this.obj.configurations.forEach((element) => {
            if (element.id === this.localTokenVal.editKeyValues.configurationId) {
              data.configuration = element;
            }
          });
          data.bxRightId = this.tokenVal.bxRightId;
          data.objectId = this.tokenVal.objectId;

          const responseBitrix = await this.$http({
            method: 'post',
            url: `https://iridi.com/customer/api_byod/?act=edit_right`,
            data: data,
          });

          if (responseBitrix.data.status !== 'success') {
            this.$toast.open({
              message: this.$t('index.'+responseBitrix.data.code),
              position: 'is-bottom-right',
              type: 'is-error',
              container: 'div.modal-card',
            });
            if(!this.localTokenVal.editKeyValues.deactivated) {
              this.isloadingUpdate = false;
              return;
            }
          }
        }

        this.$emit('init_response_update', {
          objIndex: this.objIndx,
          tokIndex: this.tokenIndex,
          tokenData: response.data.tokenData,
        });

        this.$parent.close();
      } catch (error) {
        this.$toast.open({
          message: error,
          position: 'is-bottom-right',
          type: 'is-error',
          container: 'div.modal-card',
        });
      }
      this.isloadingUpdate = false;
    },
  },
  mounted() {
    this.selectRoom(this.tokenVal.configurationId);
  },
};
</script>

<style>
.label {
  color: #444;
  font-weight: 400;
}

.limit_type_1 {
  border-top: 5px solid #eb4c64;
  padding-top: 10px;
}

.limit_type_2 {
  border-top: 5px solid #4a9ce7;
  padding-top: 10px;
}

@media screen and (min-width: 768px) {
  .modal-card {
    min-width: 500px;
  }
}
</style>



// WEBPACK FOOTER //
// Updatetoken.vue?359de4d9